import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';

const Header = ({ scrollToSection }) => {
  return (
    <header className="bg-[#004A6B] shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-0.5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center -mb-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_rinno-kfz/artifacts/xhxvn8uk_white-Photoroom%2817%29.png" 
              alt="KFZ-Sachverständigenbüro Rinno Logo" 
              className="h-16 sm:h-20 w-auto mr-3 sm:mr-4"
            />
            <div className="hidden sm:block">
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-white leading-tight">
                KFZ-Sachverständigenbüro Rinno
              </h1>
            </div>
            <div className="block sm:hidden">
              {/* Nur Logo auf Mobile, kein Text */}
            </div>
          </div>
          
          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('process')}
              className="text-white hover:text-gray-200 transition-colors duration-200 font-bold text-lg"
            >
              Unser Prozess
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-gray-200 transition-colors duration-200 font-bold text-lg"
            >
              Service & Leistungen
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-white hover:text-gray-200 transition-colors duration-200 font-bold text-lg"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-white hover:text-gray-200 transition-colors duration-200 font-bold text-lg"
            >
              Bewertungen
            </button>
            
            {/* Contact Section */}
            <div className="flex items-center space-x-4 ml-6">
              <a
                href="https://wa.me/4917662168132?text=Guten%20Tag,%0Aich%20interessiere%20mich%20für%20ein%20Kfz-Gutachten%20und%20hätte%20dazu%20ein%20paar%20Fragen.%20Ich%20freue%20mich%20über%20Ihre%20Rückmeldung"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform duration-200"
                title="WhatsApp"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_rinno-kfz/artifacts/v9tp4hx1_WhatsApp.svg.png"
                  alt="WhatsApp"
                  className="h-8 w-8"
                />
              </a>
              <span className="text-white text-lg font-light">/</span>
              <a
                href="tel:+4917662168132"
                className="flex items-center space-x-1 bg-[#B3E5FC] hover:bg-[#81D4FA] transition-colors text-black px-3 py-1.5 rounded-full text-sm font-medium shadow-sm"
                title="Anrufen"
              >
                <Phone size={16} />
                <span>Anrufen</span>
              </a>
            </div>
          </nav>
          
          {/* Mobile Contact */}
          <div className="md:hidden flex items-center space-x-3">
            <a
              href="https://wa.me/4917662168132?text=Guten%20Tag,%0Aich%20interessiere%20mich%20für%20ein%20Kfz-Gutachten%20und%20hätte%20dazu%20ein%20paar%20Fragen.%20Ich%20freue%20mich%20über%20Ihre%20Rückmeldung"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform duration-200"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_rinno-kfz/artifacts/v9tp4hx1_WhatsApp.svg.png"
                alt="WhatsApp"
                className="h-6 w-6"
              />
            </a>
            <span className="text-white text-sm font-light">/</span>
            <a
              href="tel:+4917662168132"
              className="flex items-center space-x-1 bg-[#B3E5FC] hover:bg-[#81D4FA] transition-colors text-black px-3 py-1.5 rounded-full text-sm font-medium shadow-sm"
            >
              <Phone size={16} />
              <span>Anrufen</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;